<template>
  <b-container>
    <b-row>
      <h2>{{ $t("system.profile.list") }}</h2>
      <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </b-row>

    <b-row class="mb-3">
      <router-link :to="'./create'">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-table
        ref="MyForm"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="filter"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :filter-debounce="500"
      >
        <template #thead-top>
          <b-tr style="">
            <b-th></b-th>
            <!--<b-th>
                Cachorrinho123
              </b-th> -->
            <b-th>
              <b-form-input
                v-model="filter.id"
                placeholder="Filtrar pelo Id:"
              />
            </b-th>

            <b-th>
              <b-form-input
                v-model="filter.displayName"
                type="text"
                placeholder="Filtrar pelo Nome:"
              />
            </b-th>
          </b-tr>
        </template>

        <template v-slot:cell(actions)="data">
          <router-link :to="'./edit/' + data.item.id">
            <b-button size="sm"> {{ $t("geral.editar") }} </b-button>
          </router-link>

          <router-link
            :to="
              './profileRelease/' + data.item.id + '/' + data.item.displayName
            "
          >
            <b-button class="ml-2" size="sm">
              {{ $t("geral.releases") }}
            </b-button>
          </router-link>
        </template>
      </b-table>

      <b-col>
        <table-pagination
          :currentPage.sync="tableCurrentPage"
          :pageOptions.sync="tablePageOptions"
          :rowCount.sync="tableRowCount"
          :perPage.sync="tablePerPage"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { api } from "v-viewer";
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePagination: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data: function () {
    return {
      sortBy: "displayName",
      sortDesc: false,
      isBusy: false,
      fields: [
        {
          key: "actions",
          label: "",
          thStyle: "width: 240px",
        },
        {
          key: "id",
          sortable: true,
          label: "Id",
          thStyle: "width: 150px",
        },
        {
          key: "displayName",
          sortable: true,
          label: this.$t("table.colunName"),
        },
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      filter: { displayName: "", id: "" },
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    async myProvider(ctx, callback) {
      this.isBusy = true;

      let apiFilter = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        id: ctx.filter.id,
        displayName: ctx.filter.displayName,
      };

      this.$apiScheduler
        .post("/profile/all/", apiFilter)
        .then((response) => {
          const items = response.data.items;
          console.log(response.data);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });

      return null;
    },
  },
};
</script>